import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  logError(message: string, stack: string) {
    // @todo Добавить функционал отправки ошибки на сервер
    // для последующего логгирования
    // Можно использовать такие сервисы как как Bugsnag,
    // Sentry, TrackJs и Rollbar (один из)
    console.log('LoggingService: ' + message);
  }
}
